import { useParams, useSearchParams } from 'react-router-dom';
import { walletTemplates } from 'data/shared/walletTemplates';
import { CreditCard } from 'data/shared/CreditCard';
import { CreditCardData } from 'data/shared/CreditCardData';

function formatCardNames(cards: CreditCard[]): string {
  const names = cards
    .map((id) => CreditCardData[id]?.name)
    .filter(Boolean) as string[];
  if (names.length === 0) {
    return '';
  }
  if (names.length === 1) {
    return names[0];
  }
  if (names.length === 2) {
    return `${names[0]} and ${names[1]}`;
  }
  return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`;
}

export const useHeroTitleAndDescription = (
  selectedCards: CreditCard[] = []
) => {
  const { code: pathCode } = useParams<{ code: string }>();
  const [searchParams] = useSearchParams();
  // Support /w/<template-id> path and ?wallet= query param (backward compat)
  const walletParam = pathCode || searchParams.get('wallet');

  const wallet = walletParam
    ? walletTemplates.find((w) => w.id === walletParam)
    : null;

  // Saved/shared wallet (pathCode exists but isn't a template)
  const isSavedWallet = pathCode && !wallet;

  if (isSavedWallet) {
    const cardNames = formatCardNames(selectedCards);
    return {
      title: 'Wallet summary',
      description: cardNames || '',
      author: null,
    };
  }

  return {
    title: wallet?.name || 'Build your ideal rewards wallet',
    description: wallet
      ? wallet.longEditorsNote || wallet.editorsNote || ''
      : 'Optimize your cash back or travel rewards. Save or share wallet builds. No account required.',
    author: wallet
      ? 'Sample wallet by CardClues. Not affiliated with the issuer.'
      : null,
  };
};
